export default {
      id: "ic_live_stack_circle-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_live_stack_circle-usage",
      toString: function () {
        return this.url;
      }
    }